import { createQueryData } from '../helpers/createQueryData';

const { useQuery } = createQueryData({
  endPoint: 'Acceptance/attachment_types',
});

export const useAttachmentTypesQuery = ({
  params: { addressId, acceptanceClientId } = {},
  options,
} = {}) => {
  return useQuery({
    params: { addressId, acceptanceClientId },
    options: {
      enabled: Boolean(addressId),
      staleTime: 1000 * 60 * 10,
      ...options,
    },
  });
};
